import { render, staticRenderFns } from "./ProfileBox.vue?vue&type=template&id=64b7fe14&scoped=true"
import script from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProfileBox.vue?vue&type=style&index=0&id=64b7fe14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7fe14",
  null
  
)

export default component.exports